// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"df15af5e","703":"0c6bf043"}[chunkId] + ".chunk.js";
};